import React, { useState } from "react";
import { Input, Modal, Tag } from "antd";
import { $t } from "~/i18n.js";
import { HelpLine } from "~/components/help/helpLine.jsx";

export function ConfirmLogout({ show, closeModal, history }) {
  const [confirmLogout, setConfirmLogout] = useState("");

  const handleCancel = () => {
    setConfirmLogout("");
    closeModal();
  };

  const performLogout = async () => {
    handleCancel();
    history && history.push("/login");
  };

  return (
    <Modal
      title={$t("Bevestig")}
      open={show}
      onCancel={handleCancel}
      onOk={performLogout}
      okButtonProps={{
        disabled: confirmLogout.toLowerCase() !== $t("uitloggen"),
      }}
    >
      <HelpLine>
        {$t(
          "Als het goed is hoef je niet uit te loggen. Deze gebruiker blijft ingelogd op de tablet of laptop waar je nu op zit. Als je deze gebruikt uitlogt, dan heb je een beheerder nodig die een tijdelijk wachtwoord aanmaakt om deze gebruiker weer in te loggen."
        )}
      </HelpLine>

      <p style={{ marginTop: 16 }}>
        {$t("Om te bevestigen dat je dit bewust doet, schrijft")}{" "}
        <Tag>{$t("uitloggen")}</Tag> {$t("in het veld hieronder.")}
      </p>

      <Input
        type="text"
        style={{ width: 150, margin: "10px auto" }}
        value={confirmLogout}
        onChange={(elm) => setConfirmLogout(elm.target.value)}
      />
    </Modal>
  );
}
